import {
  createBadge as publicCreateBadge,
  updateBadge as publicUpdateBadge,
  listBadges as publicListBadges,
  getBadge as publicGetBadge,
  deleteBadge as publicDeleteBadge,
  assignBadge as publicAssignBadge,
  unassignBadge as publicUnassignBadge,
  listMembersByBadge as publicListMembersByBadge,
  listBadgesPerMember as publicListBadgesPerMember,
  getMemberCountsPerBadge as publicGetMemberCountsPerBadge,
  updateBadgesDisplayOrder as publicUpdateBadgesDisplayOrder,
} from './badges-v3-badge-badges.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onBadgeAssigned as publicOnBadgeAssigned } from './badges-v3-badge-badges.public.js';
import { onBadgeUnassigned as publicOnBadgeUnassigned } from './badges-v3-badge-badges.public.js';
import { onBadgeCreated as publicOnBadgeCreated } from './badges-v3-badge-badges.public.js';
import { onBadgeDeleted as publicOnBadgeDeleted } from './badges-v3-badge-badges.public.js';
import { onBadgeUpdated as publicOnBadgeUpdated } from './badges-v3-badge-badges.public.js';

export const createBadge: MaybeContext<
  BuildRESTFunction<typeof publicCreateBadge> & typeof publicCreateBadge
> = /*#__PURE__*/ createRESTModule(publicCreateBadge);
export const updateBadge: MaybeContext<
  BuildRESTFunction<typeof publicUpdateBadge> & typeof publicUpdateBadge
> = /*#__PURE__*/ createRESTModule(publicUpdateBadge);
export const listBadges: MaybeContext<
  BuildRESTFunction<typeof publicListBadges> & typeof publicListBadges
> = /*#__PURE__*/ createRESTModule(publicListBadges);
export const getBadge: MaybeContext<
  BuildRESTFunction<typeof publicGetBadge> & typeof publicGetBadge
> = /*#__PURE__*/ createRESTModule(publicGetBadge);
export const deleteBadge: MaybeContext<
  BuildRESTFunction<typeof publicDeleteBadge> & typeof publicDeleteBadge
> = /*#__PURE__*/ createRESTModule(publicDeleteBadge);
export const assignBadge: MaybeContext<
  BuildRESTFunction<typeof publicAssignBadge> & typeof publicAssignBadge
> = /*#__PURE__*/ createRESTModule(publicAssignBadge);
export const unassignBadge: MaybeContext<
  BuildRESTFunction<typeof publicUnassignBadge> & typeof publicUnassignBadge
> = /*#__PURE__*/ createRESTModule(publicUnassignBadge);
export const listMembersByBadge: MaybeContext<
  BuildRESTFunction<typeof publicListMembersByBadge> &
    typeof publicListMembersByBadge
> = /*#__PURE__*/ createRESTModule(publicListMembersByBadge);
export const listBadgesPerMember: MaybeContext<
  BuildRESTFunction<typeof publicListBadgesPerMember> &
    typeof publicListBadgesPerMember
> = /*#__PURE__*/ createRESTModule(publicListBadgesPerMember);
export const getMemberCountsPerBadge: MaybeContext<
  BuildRESTFunction<typeof publicGetMemberCountsPerBadge> &
    typeof publicGetMemberCountsPerBadge
> = /*#__PURE__*/ createRESTModule(publicGetMemberCountsPerBadge);
export const updateBadgesDisplayOrder: MaybeContext<
  BuildRESTFunction<typeof publicUpdateBadgesDisplayOrder> &
    typeof publicUpdateBadgesDisplayOrder
> = /*#__PURE__*/ createRESTModule(publicUpdateBadgesDisplayOrder);
/**
 * Triggered when a member receives a badge.
 */
export const onBadgeAssigned: BuildEventDefinition<
  typeof publicOnBadgeAssigned
> = createEventModule(publicOnBadgeAssigned);
/**
 * Triggered when a member's badge is removed.
 */
export const onBadgeUnassigned: BuildEventDefinition<
  typeof publicOnBadgeUnassigned
> = createEventModule(publicOnBadgeUnassigned);
/**
 * Triggered when a badge is created.
 */
export const onBadgeCreated: BuildEventDefinition<typeof publicOnBadgeCreated> =
  createEventModule(publicOnBadgeCreated);
/**
 * Triggered when a badge is deleted.
 */
export const onBadgeDeleted: BuildEventDefinition<typeof publicOnBadgeDeleted> =
  createEventModule(publicOnBadgeDeleted);
/**
 * Triggered when a badge is updated.
 */
export const onBadgeUpdated: BuildEventDefinition<typeof publicOnBadgeUpdated> =
  createEventModule(publicOnBadgeUpdated);

export {
  SortOrder,
  WebhookIdentityType,
} from './badges-v3-badge-badges.universal.js';
export {
  Badge,
  CreateBadgeRequest,
  CreateBadgeResponse,
  UpdateBadgeRequest,
  UpdateBadgeResponse,
  ListBadgesRequest,
  Paging,
  ListBadgesResponse,
  PagingMetadata,
  QueryBadgesRequest,
  Sorting,
  QueryBadgesResponse,
  GetBadgeRequest,
  GetBadgeResponse,
  DeleteBadgeRequest,
  DeleteBadgeResponse,
  CountBadgesRequest,
  CountBadgesResponse,
  AssignBadgeRequest,
  AssignBadgeResponse,
  BadgeAssigned,
  AssignBadgesRequest,
  AssignBadgesResponse,
  UnassignBadgeRequest,
  UnassignBadgeResponse,
  BadgeUnassigned,
  ListMembersRequest,
  ListMembersResponse,
  ListMembersBadgeIdsRequest,
  ListMembersBadgeIdsResponse,
  MemberBadgeIds,
  GetMemberCountsPerBadgeRequest,
  GetMemberCountsPerBadgeResponse,
  BadgeMemberCount,
  UpdateBadgesDisplayOrderRequest,
  UpdateBadgesDisplayOrderResponse,
  ListMembersWithBadgesRequest,
  CursorPaging,
  ListMembersWithBadgesResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  BaseEventMetadata,
  EventMetadata,
  BadgeAssignedEnvelope,
  BadgeUnassignedEnvelope,
  BadgeCreatedEnvelope,
  BadgeDeletedEnvelope,
  BadgeUpdatedEnvelope,
  UpdateBadge,
  ListBadgesOptions,
  ListMembersByBadgeOptions,
} from './badges-v3-badge-badges.universal.js';
